const ERROR_MESSAGES = {
  EMAIL_REQUIRED: 'Email is required',
  FIRST_NAME_REQUIRED: 'First name is required',
  LAST_NAME_REQUIRED: 'Last name is required',
  PASSWORD_REQUIRED: 'Password is required',
  PASSWORD_INVALID: 'Please enter a valid password. Minimum 6 characters.',
  WRONG_EMAIL_FORMAT: 'Invalid email format.',
};

const PRIVACY_POLICY_URL = 'https://www.thinkific.com/privacy-policy';
const TERMS_AND_CONDITIONS_URL = 'https://www.thinkific.com/terms-of-service';

export default ERROR_MESSAGES;
export { PRIVACY_POLICY_URL, TERMS_AND_CONDITIONS_URL };
